import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getComboLineaGeneticaActiva`, method: 'GET', body: null, token: token})
}